import { useTranslation } from "react-i18next"

import type { FC } from "react"

import type { PowerlineTowerFeatureProps } from "types/geolocation.types"

import useRoutes from "helpers/hooks/useRoutes"
import useContextDevices from "helpers/hooks/devices/useContextDevices"
import EntityPopup, { type EntityPopupField } from "./EntityPopup"
import { getFeatureFields } from "./featureFields"

interface TowerPopupProps {
  data: PowerlineTowerFeatureProps
  hideButton?: boolean
}

const TowerPopup: FC<TowerPopupProps> = ({ data, hideButton }) => {
  const { t } = useTranslation()
  const { baseOrgURL } = useRoutes()

  // The type is stored as a code, so it reads by its translated name.
  const typeField: EntityPopupField | undefined = data.type
    ? {
        label: t("geo_info.TYPE"),
        type: "text",
        value: t(`tower_information.TYPES.${data.type.toUpperCase()}`, data.type),
      }
    : undefined

  const fields = getFeatureFields(
    "PowerlineTower",
    data,
    t,
    typeField && { type: typeField },
  )

  const { devices, isLoading: devicesLoading } = useContextDevices({
    asset: { entity: "tower", id: data.id },
  })

  return (
    <EntityPopup
      entity="tower"
      name={data.name}
      fields={fields}
      id={data.id}
      devices={{ items: devices, loading: devicesLoading }}
      href={hideButton ? undefined : `${baseOrgURL}/towers/${data.id}`}
    />
  )
}

export default TowerPopup
